import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StringLiteralLike } from 'typescript';
import { Observable, observable, of } from 'rxjs';
import { NbAuthService } from '@nebular/auth';
import { map, switchMap } from 'rxjs/operators';
import { AuthService } from '../../auth.service';
import { DialogConfirmComponent } from '../dialog-confirm/dialog-confirm.component';
import { SharedServiceService } from '../../shared-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'slt-dialog-logout',
  templateUrl: './dialog-logout.component.html',
  styleUrls: ['./dialog-logout.component.scss']
})
export class DialogLogoutComponent implements OnInit {

  selectedEntidad$: Observable<number | null>;
  iIDEntidad: any;
  selectedPerfil$: Observable<number>;
  iIDPerfil: any;
  router: any;
  sessionMessage: string = '';
  unixTimestamp = 0;
  boolRenovar: boolean = false;
  boMostrarSpinner: boolean = false;
  selectedTime$: Observable<number | null>;
  timeExpire: any;

  sloUrl = `/api/Saml/InitiateSingleLogout?returnUrl=${origin}/auth/logout`;

  constructor(public dialogRef: MatDialogRef<DialogLogoutComponent>,
    @Inject(MAT_DIALOG_DATA) public message: StringLiteralLike,
    private nbAuthService: NbAuthService,
    private authService: AuthService,
    private dialog: MatDialog,
    private _sharedService: SharedServiceService,
    private _snackBar: MatSnackBar
  ) {
    this.selectedEntidad$ = nbAuthService.onTokenChange().pipe(
      map(token => +token.getPayload().iIDEntidad)
    );
    this.selectedEntidad$.subscribe(idEntidad => {
      this.iIDEntidad = idEntidad;
    })
    // console.log("iDEntidad: ", this.iIDEntidad);
    this.selectedPerfil$ = nbAuthService.onTokenChange().pipe(
      map(token => +token.getPayload().iIDPerfil)
    );
    this.selectedPerfil$.subscribe(idPerfil => {
      this.iIDPerfil = idPerfil;
    })
    this.selectedTime$ = nbAuthService.onTokenChange().pipe(
      map(token => +token.getPayload().timeExpire)
    );
    this.selectedTime$.subscribe(time => {
      this.timeExpire = time;
    })

    // let time = localStorage.getItem('timeExpire')
    // this.timeExpire = time ? parseInt(time, 10) : null;
    if (!isNaN(this.iIDEntidad) || !isNaN(this.iIDPerfil)) {
      this.boolRenovar = true;
    } else {
      this.boolRenovar = false;
    }
  }

  ngOnInit(): void {
  }

  clickCancelar(): void {
    this.dialogRef.close();
    localStorage.clear();
    //window.location.href = environment.sloUrl;
    this.nbAuthService.logout('email').subscribe(res => {
      res.isSuccess() && this.router.navigate(['../auth'])
    })
    window.location.href = this.sloUrl;
  }

  clickRenovar(): void {
    // Primero, realizamos la renovación del token
    this.boMostrarSpinner = true;
    this.authService.updateToken(this.iIDEntidad, this.iIDPerfil, this.timeExpire).pipe(
      switchMap(auth => {
        if (auth) {
          this.sessionMessage = "Su sesión fue renovada";
          const dialogRef = this.dialog.open(DialogConfirmComponent, {
            width: '25%',
            data: this.sessionMessage
          });

          this.dialogRef.close();

          return this.nbAuthService.getToken().pipe(
            map(token => {
              if (token.getPayload() != null) {
                if (token.isValid()) {
                  this.unixTimestamp = token.getPayload().exp;
                  const date = new Date(this.unixTimestamp * 1000);
                  const dateNow = new Date();
                  let secondsSend = date.getTime() - dateNow.getTime();
                  secondsSend = secondsSend / 1000;
                  let secondsTimer = Math.floor(secondsSend);
                  this._sharedService.emitChange({
                    defaultTimeoutSeconds: secondsTimer,
                    defaultShowPopupSeconds: 60,
                    dateExp: this.unixTimestamp
                  });
                  // console.log("Entro al nbAuthService");
                  this.boMostrarSpinner = false;
                  return true;
                }
                return false;
              } else {
                return false;
              }
            })
          );
        } else {
          this.boMostrarSpinner = false;
          this._snackBar.open("No se pudo renovar la sesión, intentelo nuevamente.", "X", {
            duration: 5000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['red-snackbar']
          })

          this.router.navigateByUrl('/auth/loginDav');
          return of(false);
        }
      })
    ).subscribe(result => {
      if (result) {
        // Realizar acciones adicionales si es necesario despues de suscribirse a updatetoken
      }
    }, error => {
      console.error(error);
    });
  }

}
